import { FC } from 'react';
import useStore from '@hooks/useStore';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import CopyToClipboard from '@components/CopyToClipboard';

import { ReactComponent as CopyIcon } from '@assets/images/icons/copy.svg';

import useStyles from './styles';

export interface Item {
  key: string;
  label: string;
  value: string;
  copyValue: string;
  copyLabel: string;
}

export interface Step {
  title: string;
  items?: Item[];
}

export interface DlocalBbvaBankTabProps {
  cieAgreementInfo: Step[];
}

const DlocalBbvaBankTab: FC<DlocalBbvaBankTabProps> = ({ cieAgreementInfo }) => {
  const {
    links: {
      coBrandingConfig: { primaryColor, secondaryColor },
    },
  } = useStore();
  const css = useStyles({ primaryColor, secondaryColor });

  return (
    <Box data-testid="dlocal-spei-bbva-bank-tab" className={css.root}>
      <ol>
        {cieAgreementInfo.map(({ title, items }: Step) => (
          <li role="step" key={title}>
            <div className={css.caption}>{title}</div>
            {items?.map(({ key, label, value, copyValue, copyLabel }: Item) => (
              <Box display="flex" key={key} alignItems="center" justifyContent="space-between">
                <Box>
                  <div className={css.label}>{label}</div>
                  <div className={css.value}>{value}</div>
                </Box>
                <Box>
                  <IconButton className={css.copyIcon}>
                    <CopyToClipboard tooltipText={copyLabel} text={copyValue}>
                      <SvgIcon component={CopyIcon} />
                    </CopyToClipboard>
                  </IconButton>
                </Box>
              </Box>
            ))}
          </li>
        ))}
      </ol>
    </Box>
  );
};

export default DlocalBbvaBankTab;
